export default "__VITE_ASSET__B8EQ_MSi__"